module.exports = __webpack_public_path__ + "img/gch3.ef484791.png";